import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface LegalMarkdownProps {
    content: string
}

export const LegalMarkdown: React.FC<LegalMarkdownProps> = ({ content }) => {
    return (
        <main
            style={{
                maxWidth: '800px',
                margin: '0 auto',
                padding: '2rem 1rem',
                lineHeight: 1.6,
                fontSize: '0.95rem',
            }}
        >
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h1: ({ node, ...props }) => (
                        <h1
                            style={{ fontSize: '1.6rem', marginBottom: '1rem', marginLeft: '0' }}
                            {...props}
                        />
                    ),
                    h2: ({ node, ...props }) => (
                        <h2 style={{ fontSize: '1.3rem', marginTop: '1.5rem' }} {...props} />
                    ),
                    h3: ({ node, ...props }) => (
                        <h3 style={{ fontSize: '1.1rem', marginTop: '1rem' }} {...props} />
                    ),
                    p: ({ node, ...props }) => <p style={{ margin: '0.5rem 0' }} {...props} />,
                    ul: ({ node, ...props }) => (
                        <ul
                            style={{
                                margin: '0.5rem 0',
                                listStyleType: 'disc',
                                paddingLeft: '1.5rem',
                            }}
                            {...props}
                        />
                    ),
                    ol: ({ node, ...props }) => (
                        <ol
                            style={{
                                margin: '0.5rem 0',
                                listStyleType: 'decimal',
                                paddingLeft: '1.5rem',
                            }}
                            {...props}
                        />
                    ),
                    blockquote: ({ node, ...props }) => (
                        <blockquote
                            style={{
                                borderLeft: '4px solid #ddd',
                                paddingLeft: '0.75rem',
                                color: '#555',
                                margin: '0.75rem 0',
                            }}
                            {...props}
                        />
                    ),
                }}
            >
                {content}
            </ReactMarkdown>
        </main>
    )
}
